module.exports = __webpack_public_path__ + "static/media/owl-success-data-privacy.f40165b8.svg";